module.exports = __webpack_public_path__ + "assets/img/mm_icon.0e900e57.svg";